import { Stack, Typography } from '@mui/material';
import { TypographyProps } from '@mui/material/Typography';
import React from 'react';

interface Props {
  title?: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  titleVariant?: TypographyProps['variant'];
}

const StudyReportCardHeader: React.FC<Props> = ({ title, description, actions, titleVariant = 'subtitle2' }) => (
  <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1.5}>
    <Stack spacing={0.25} sx={{ minWidth: 0, flex: 1 }}>
      {title ? (
        <Typography variant={titleVariant} fontWeight={600} sx={{ minWidth: 0 }}>
          {title}
        </Typography>
      ) : null}
      {description}
    </Stack>
    {actions ? (
      <Stack direction="row" spacing={0.5} alignItems="center" sx={{ flexShrink: 0 }}>
        {actions}
      </Stack>
    ) : null}
  </Stack>
);

export default StudyReportCardHeader;
